module.exports = __webpack_public_path__ + "img/lPutA.64d884b4.svg";